var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    fill: "none",
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1CC0A0",
    fillRule: "evenodd",
    d: "M17.287 3.243c.39 0 .713.323.713.734v.38a.73.73 0 0 1-.713.734H.714A.73.73 0 0 1 0 4.357v-.38c0-.411.324-.734.714-.734H3.63c.592 0 1.107-.421 1.24-1.015l.153-.682C5.261.617 6.042 0 6.935 0h4.13c.884 0 1.674.617 1.902 1.497l.163.73a1.28 1.28 0 0 0 1.241 1.016h2.916Zm-1.481 13.891c.304-2.837.837-9.577.837-9.645a.746.746 0 0 0-.18-.558.726.726 0 0 0-.524-.234H2.069a.707.707 0 0 0-.524.234.79.79 0 0 0-.19.558l.052.647c.142 1.763.538 6.674.794 8.998.18 1.712 1.304 2.788 2.93 2.827 1.256.03 2.55.04 3.873.04 1.245 0 2.51-.01 3.805-.04 1.684-.029 2.806-1.086 2.997-2.827Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.7166b37ae0188535ab0d2d89f494bf16.svg";
export { ForwardRef as ReactComponent };